export const SET_VENDORENTERTAINMENT = 'SET_VENDORENTERTAINMENT';
export const GET_VENDORENTERTAINMENT = 'GET_VENDORENTERTAINMENT';
